import React, { useEffect, useState } from 'react';
import Config from '../../../../config/config';
import ApiUrls from '../../../../constants/ApiUrls';
import { getLabelsByLanguage } from '../../../../utilites/util';
import LoadingIndicator from '../../xnp/common/loading-indicator/LoadingIndicator';
import ErrorInformation from '../error/ErrorInformation';
import SuccessMessage from '../success/SuccessMessage';
import TransactionOverviewDetails from './transaction-overview-details';
import './scss/index.scss';
import Button from '../../../components/buttons/Button';
import { useDispatch } from 'react-redux';
import { topupAnalyticsStepAction } from '../../../../app/store/analytics/actions';

export type OrderDetailsResponse = {
  id: number;
  orderNumber: string;
  currencyCode: null;
  transactionAmount: number;
  transactionDateAndTime: string;
  status: string;
  ccType: string;
  cardholderName: string;
  cardholderSurname: string;
  cardholderEmail: string;
  email: string;
  cardDetails: string;
  approvalCode: string;
  referenceNumber: string;
  ipAddress: string;
  phoneNumber: string;
  type: string;
};

const isOrderDetailsResponse = (obj: any) => {
  return (
    obj.hasOwnProperty('id') &&
    obj.hasOwnProperty('orderNumber') &&
    obj.hasOwnProperty('transactionAmount') &&
    typeof obj.transactionAmount === 'number'
  );
};

interface Props {
  handleStepChange: (stepNumber: number) => void;
}

const TopupTransactionOverview: React.FC<Props> = ({ handleStepChange }) => {
  const dispatch = useDispatch();
  const { serviceOutOfFunction, paymentTopupNotSuccessful, newPurchaseButton } = getLabelsByLanguage();

  const [transactionDetails, setTransactionDetails] = useState<null | OrderDetailsResponse>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setHasErrored] = useState(false);
  const url = new URL(window.location.toString());
  const orderNumber = url.searchParams.get('orderNumber') || '';

  const topupFailed = url.pathname.includes('fail');

  const handleNewPurchase = () => {
    handleStepChange(1);
  };

  useEffect(() => {
    if (topupFailed) setHasErrored(true);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (transactionDetails) {
      dispatch(
        topupAnalyticsStepAction({
          step: 3,
          amount: transactionDetails.transactionAmount,
          topupType: transactionDetails.type,
        })
      );
    }

    if (!topupFailed && transactionDetails) {
      sessionStorage.removeItem('topupData');
      sessionStorage.setItem('topupData', JSON.stringify({ email: transactionDetails?.email, checked: true }));
    }
  }, [transactionDetails]);

  useEffect(() => {
    if (orderNumber) {
      setIsLoading(true);

      fetch(`${Config.api.baseUrl}${ApiUrls.TOPUP}/details?orderNumber=${orderNumber}`)
        .then((response) => {
          response
            .json()
            .then((resp: OrderDetailsResponse) => {
              if (isOrderDetailsResponse(resp)) {
                setTransactionDetails(resp);
              } else {
                setHasErrored(true);
              }
            })
            .catch((e) => {
              setHasErrored(true);
              console.log(e);
            });
        })
        .catch((e) => {
          setHasErrored(true);
          console.log(e);
        })
        .finally(() => setIsLoading(false));
    }
  }, [orderNumber]);

  return (
    <>
      {isLoading && (
        <div className="text-center justify-content-center align-items-center">
          <LoadingIndicator />
        </div>
      )}

      {!topupFailed && <SuccessMessage />}

      {isError && <ErrorInformation errors={[topupFailed ? paymentTopupNotSuccessful : serviceOutOfFunction]} />}

      {transactionDetails && (
        <>
          <TransactionOverviewDetails data={transactionDetails} />
          <section className="d-flex justify-content-center mt-5">
            <Button
              type="button"
              disabled={false}
              onClick={() => {
                handleNewPurchase();
              }}
              style="btn-blue-yettel"
            >
              {newPurchaseButton}
            </Button>
          </section>
        </>
      )}
    </>
  );
};

export default TopupTransactionOverview;
